export const content = {
    domain: "Balance Credit",
    footer: "balanecedil.com",
    title1: "The Funds You Need Fast",
  };
  